import * as React from 'react';

import { CollapsibleSection } from 'common/components';
import { PK } from 'common/types';
import { TAGGING_CONTENT_TYPES } from 'modules/tagging/consts';
import { TagsForm } from 'modules/tagging/components';
import { useBlogTags, useBlogTagsUpdate } from '../queries';
import { blogTagsValidationSchema } from '../consts';
import { extractFirstValue, extractValues } from 'common/utils/tags';

type Props = {
  setIsTags?: (isTags: boolean) => void;
  pk?: PK;
};

const BlogTagsPicker = ({ pk, setIsTags }: Props) => {
  const { data: blogTagData } = useBlogTags(pk);
  const isTags =
    blogTagData?.category &&
    Array.isArray(blogTagData?.category) &&
    blogTagData?.category.length > 0;

  React.useEffect(() => {
    setIsTags?.(!!isTags);
  }, [isTags, setIsTags]);

  const { mutate: updateBlogTag, isSuccess, isLoading, isError } = useBlogTagsUpdate();
  const saveTags = (values: any) => {
    const payload: Record<string, any> = {};

    const category = extractValues(values.category);
    if (category) payload.category = category;

    const habit = extractValues(values.habit);
    if (habit) payload.habit = habit;

    const habitReplacement = extractFirstValue(values.habit_replacement);
    if (habitReplacement) payload.habit_replacement = habitReplacement;

    const subcategory = extractValues(values.subcategory);
    if (subcategory) payload.subcategory = subcategory;

    if (values.minutes_to_read) {
      payload.minutes_to_read = values.minutes_to_read;
    }

    const season = extractValues(values.season);
    if (season) payload.season = season;

    const gender = extractFirstValue(values.gender);
    if (gender) payload.gender = gender;

    payload.pk = pk;

    updateBlogTag(payload as any);
  };

  return (
    <>
      <CollapsibleSection
        title="Add tags"
        saveStatus={{ isSuccess, isLoading, isError }}
        disabled={!pk}
        divider={false}
      >
        <TagsForm
          validationSchema={blogTagsValidationSchema}
          contentType={TAGGING_CONTENT_TYPES.BLOG}
          defaultValues={blogTagData}
          onSubmit={saveTags}
          isSubmitting={isLoading}
        />
      </CollapsibleSection>
    </>
  );
};

export default BlogTagsPicker;
